import { Molecule as MoleculeData, Position } from '@interfaces/molecule'
import collect, { Collection } from 'collect.js'
import ModelConnection from '@/models/connection'
import { Connection as ConnectionData } from '@/interfaces/connection'

export default class ModelMolecule {
  private data: MoleculeData

  constructor(data: MoleculeData) {
    this.data = data
  }

  get id(): string {
    return this.data.id
  }

  get dbID(): number {
    return this.data.dbID
  }

  get category(): string | null {
    return this.data.category
  }

  get title(): string {
    return this.data.title
  }

  get type(): string {
    return this.data.type
  }

  get size(): string {
    return this.data.size
  }

  get mirrors(): string[] {
    return this.data.mirrors
  }

  get position(): Position {
    return this.data.position
  }

  get hasFormula(): boolean {
    return this.data.hasFormula
  }

  get hasActiveFormula(): boolean {
    return this.activeFormula !== null
  }

  get defaultFormula(): string | null {
    return this.data.defaultFormula
  }

  get activeFormula(): string | null {
    return this.data.activeFormula
  }

  get c6Formula(): string | null {
    return this.data.c6Formula
  }

  get c4Formula(): string | null {
    return this.data.c4Formula
  }

  get c2Formula(): string | null {
    return this.data.c2Formula
  }

  get connections(): Collection<ModelConnection> {
    return collect(this.data.connections)
      .transform((connectionData: ConnectionData) => new ModelConnection(connectionData))
  }

  public hasConnectionTo(modelMolecule: ModelMolecule): boolean {
    return this.connections
      .contains((modelConnection: ModelConnection) => modelConnection.toID === modelMolecule.id)
  }

  public getConnectionTo(modelMolecule: ModelMolecule): ModelConnection {
    return this.connections
      .first((modelConnection: ModelConnection) => modelConnection.toID === modelMolecule.id)
  }

  public shouldCreateProduct(currentMolecule: ModelMolecule) {
    if (this.id === '1oxv7zxd' && currentMolecule.id === 'j2971q94') {
      return false
    }

    return true
  }
}
